// imports
import LazyLoad from "vanilla-lazyload";
const Flickity = require("flickity");
require("flickity-hash");
require("flickity-fade");
import Lenis from "@studio-freight/lenis";
import Simple from "simplelightbox";
// require("fizzy-ui-utils");
import "./components/navigation.js";
import "./components/story.js";
import "./components/video-modals.js";

var body = document.querySelector("body");
var html = document.querySelector("html");
var styleDir = object_name.stylesheetDirectory;
const $ = require("jquery");

var Accordion = require("vanilla-js-accordion");

setTimeout(function () {
  body.classList.add("ready");
}, 100);
setTimeout(function () {
  document.querySelector("#loading").remove();
}, 350);

//lazy load options
const lazyLoadOptions = {};
const pageLazyLoad = new LazyLoad(lazyLoadOptions);
pageLazyLoad.update();
$(document).on("sf:ajaxfinish", ".searchandfilter", function () {
  pageLazyLoad.update();
});

window.addEventListener("scroll", function () {
  if (window.scrollY > 50) {
    document.body.classList.add("scrolled");
  } else {
    document.body.classList.remove("scrolled");
  }
});

let carousel = document.getElementById("text-carousel");
if (carousel) {
  let currentIndex = 0;
  let items = document.querySelectorAll("#text-carousel .carousel-item");
  items.forEach((item, index) => {
    if (index !== 0) item.style.display = "none"; // Hide all items except the first one
  });

  function nextText() {
    items[currentIndex].style.display = "none"; // Hide current item
    currentIndex = (currentIndex + 1) % items.length; // Update index
    items[currentIndex].style.display = "block"; // Show next item
  }

  // Set interval for automatic text change
  setInterval(nextText, 1250);
}

let gallery = new SimpleLightbox(".lightbox a", {
  // spinner: false,
  // animationSpeed: 1,
  closeText: "",
  animationSlide: false,
  animationSpeed: 1,
  heightRatio: 0.8,
  // fadeSpeed: 0,
  // animationSlide: false,
});

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

var rows = document.querySelectorAll(".animate-when-visible");
var elementInViewport = debounce(function () {
  rows.forEach(function (i) {
    var bounding = i.getBoundingClientRect();
    var viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;

    // Add class when the top of the element is halfway up the screen
    if (bounding.top <= viewportHeight * 0.75) {
      i.classList.add("animating");
    }

    // Remove class when the element has completely left the screen
    if (bounding.bottom <= 0) {
      i.classList.remove("animating");
    }
  });
}, 5);
document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("load", elementInViewport, false);
  window.addEventListener("scroll", elementInViewport, false);
});

let quotesCarousels = document.querySelectorAll(".quotes-carousel");
let quoteCarousel = function () {
  quotesCarousels.forEach((i) => {
    // let progressBar = i.parentElement.querySelector(".progress-bar");
    let flkty = new Flickity(i, {
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      resize: true,
      draggable: true,
      prevNextButtons: false,
      pageDots: true,
      fade: true,
    });
  });
};
if (quotesCarousels) {
  quoteCarousel();
}

let timelinesCarousels = document.querySelectorAll(".timeline-carousel");
let timelineCarousel = function () {
  timelinesCarousels.forEach((i) => {
    // let progressBar = i.parentElement.querySelector(".progress-bar");
    let flkty = new Flickity(i, {
      draggable: true,
      prevNextButtons: false,
      wrapAround: false,
      contain: false,
      cellAlign: "left",
      pauseAutoPlayOnHover: false,
      pageDots: false,
      arrowShape: {
        x0: 20,
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 30,
        x3: 30,
      },
    });

    document.querySelector(".carousel-next-t").addEventListener("click", () => {
      flkty.next();
    });

    function carouselResize() {
      flkty.resize();
      setTimeout(function () {
        let $timelinePostHeight = $(".timeline-il").outerHeight(true);
        let windowWidth = window.innerWidth;
        if (windowWidth > 767) {
          $(".timeline-wrapper").css("height", $timelinePostHeight * 2 + "px");
        } else {
          $(".timeline-wrapper").css("height", $timelinePostHeight * 1 + "px");
        }
      }, 100);
    }

    setTimeout(() => {
      carouselResize();
    }, 200); // A short delay

    window.addEventListener("resize", () => {
      carouselResize();
    });
  });
};
if (timelinesCarousels) {
  timelineCarousel();
}

let splitCarousels = document.querySelectorAll(".split-carousel");
let splitCarousel = function () {
  splitCarousels.forEach((i) => {
    // let progressBar = i.parentElement.querySelector(".progress-bar");
    let flkty = new Flickity(i, {
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      resize: true,
      draggable: true,
      prevNextButtons: false,
      pageDots: true,
      fade: false,
    });
  });
};
if (splitCarousels) {
  splitCarousel();
}

var Accordionsccordions = document.querySelectorAll(".accordion");
var kAccordion = function () {
  Accordionsccordions.forEach((i) => {
    let inAccordion = new Accordion(i, {
      item: ".expandable-section",
      target: ".target",
      control: ".target", // in this case the target is also acting as the control
      panel: ".panel",
      allowMultiple: false,
      attribute: "data-status",
      expanded: "tab-open",
      contracted: "tab-closed",
      prefix: "accordion-",
      transition: "height .35s",
      setFocus: "none", // options: none, item, panel, target, control, first
      hashEnabled: true, // use hash in URL to open accordion item
    });
  });
};

if (Accordionsccordions) {
  kAccordion();
}

$(document).on("sf:ajaxfinish", ".searchandfilter", function () {
  var Accordionsccordions = document.querySelectorAll(".accordion");
  var kAccordion = function () {
    Accordionsccordions.forEach((i) => {
      let inAccordion = new Accordion(i, {
        item: ".expandable-section",
        target: ".target",
        control: ".target", // in this case the target is also acting as the control
        panel: ".panel",
        allowMultiple: false,
        attribute: "data-status",
        expanded: "tab-open",
        contracted: "tab-closed",
        prefix: "accordion-",
        transition: "height .35s",
        setFocus: "none", // options: none, item, panel, target, control, first
        hashEnabled: true, // use hash in URL to open accordion item
      });
    });
  };
  kAccordion();
});

function showTooltip(event) {
  let tooltipText = this.getAttribute("data-tooltip");
  let tooltipElement = document.createElement("div");
  tooltipElement.className = "custom-tooltip";
  tooltipElement.textContent = tooltipText;

  // Set initial styles for animation
  tooltipElement.style.opacity = "0";
  tooltipElement.style.transform = "translate(-50%, 12px)";
  this.children[0].appendChild(tooltipElement); // Append tooltip as a child of the span

  setTimeout(() => {
    tooltipElement.style.opacity = "1";
    tooltipElement.style.transform = "translate(-50%, 0px)";
  }, 10); // A short delay
}

// Function to hide the tooltip
function hideTooltip() {
  let tooltips = this.querySelectorAll(".custom-tooltip");
  tooltips.forEach((tooltip) => {
    tooltip.remove();
  });
}

// Attach showTooltip and hideTooltip functions to all elements with data-tooltip attribute
let tooltipTriggers = document.querySelectorAll("a[data-tooltip]");
tooltipTriggers.forEach((el) => {
  el.addEventListener("mouseover", showTooltip);
  el.addEventListener("touchstart", showTooltip);
  el.addEventListener("mouseout", hideTooltip);
  el.addEventListener("touchend", hideTooltip);
});

var Masonry = require("masonry-layout");

var msnryContainers = document.querySelectorAll(".masonry-grid");

msnryContainers.forEach(function (container) {
  var msnry = new Masonry(container, {
    itemSelector: ".masonry-item",
  });
});

var Accordion = require("vanilla-js-accordion");

let accordions = [];
var options = {
  item: ".menu-item-has-children",
  target: ".menu-accordion-control",
  control: ".menu-accordion-control",
  panel: ".sub-menu",
  allowMultiple: false,
  attribute: "data-status",
  expanded: "tab-open",
  contracted: "tab-closed",
  prefix: "accordion-",
  transition: "all .3s",
  setFocus: "none", // options: none, item, panel, target, control, first
  hashEnabled: true, // use hash in URL to open accordion item
};

document.querySelectorAll(".menu-accordion").forEach((i) => {
  var mmAccordion = new Accordion(i, options);
  accordions.push(mmAccordion); // Add each accordion to the list
});

const switcher = document.getElementById("gfgf-language-switcher");

// Check if the switcher is present in the DOM
if (switcher) {
  const menu = document.querySelector("#gfgf-language-menu"); // Adjust the selector as necessary

  // Function to toggle the display of the language menu
  function toggleMenuDisplay(event) {
    menu.classList.toggle("hidden");
  }

  // Attach click event listener to the language switcher
  switcher.addEventListener("click", toggleMenuDisplay);

  // Close the menu when a link inside the menu is clicked
  menu.addEventListener("click", function (event) {
    if (event.target.tagName === "A") {
      menu.classList.add("hidden");
    }
  });

  // Close the menu when clicking outside of the menu
  document.addEventListener("click", function (event) {
    if (!switcher.contains(event.target)) {
      menu.classList.add("hidden");
    }
  });
}
